<template>
  <HCard
    v-if="propertyData?.lead_owner != null && (!propertyData.option || (propertyData.option && propertyData.off_market)) && !propertyData.offer && !propertyData.precontract"
    color="white"
  >
    <HH3
      class="text-center mb-3"
    >
      Ce bien vous intéresse ?
    </HH3>
    <HH5
      class="text-center"
    >
      Contactez-nous !
    </HH5>

    <div class="lead-owner-section mt-5 mx-auto">
      <VAvatar size="x-large">
        <VImg
          :src="propertyData?.lead_owner?.avatar_url"
          cover
        />
      </VAvatar>
      <div class="ml-2">
        <div class="name">
          {{ propertyData?.lead_owner?.first_name }}
          {{ propertyData?.lead_owner?.last_name }}
        </div>
        <div class="role">
          {{ propertyData?.lead_owner?.job_title }}
        </div>
      </div>
    </div>

    <div class="form-section">
      <LazyHContactForm @submit:end="didSaveContact">
        <template #append>
          <div class="form-group">
            <v-textarea
              v-model="comment"
              variant="outlined"
              rows="5"
              class="form-control"
              style="resize: none; width: 100%;"
              required
            />
          </div>

          <div class="form-check">
            <input
              id="cgu"
              v-model="cgu"
              type="checkbox"
              required
              class="form-check-input"
            >
            <label
              class="form-check-label"
              for="cgu"
            >
              J'ai pris connaissance et accepte les <a
                href="/mentions-legales"
                target="_blank"
              >conditions générales d'utilisation</a>
            </label>
          </div>

          <div class="form-check">
            <input
              id="selling"
              v-model="selling"
              type="checkbox"
              class="form-check-input"
            >
            <label
              class="form-check-label"
              for="selling"
            >
              J'ai également un bien à vendre
            </label>
          </div>
        </template>

        <template #submitButton>
          <HButton
            tag="submit"
            color="purple"
            :disabled="isSending || sent"
            class="mt-4 mx-auto"
          >
            {{ buttonLabel }}
          </HButton>
        </template>
      </LazyHContactForm>
    </div>
  </HCard>
</template>

<script lang="ts" setup>
import type { ContactModel } from '~/types'

const props = defineProps<{
  propertyData?: Record<string, any>,
}>()

const cgu = ref(false)
const selling = ref(false)
const comment = ref('Bonjour, \n\nSerait-il possible d\'avoir plus d\'informations sur le bien ? \n\nCordialement.')
const isSending = ref(false)
const sent = ref(false)

const buttonLabel = computed(() => {
  if (sent.value) {
    return 'Envoyé !'
  } else if (isSending.value) {
    return 'Envoi...'
  } else {
    return 'Envoyer'
  }
})

async function didSaveContact ({ mainContact } : { mainContact: ContactModel }) {
  if (cgu.value && !isSending.value) {
    isSending.value = true

    const contactId = mainContact.id

    let leadId
    if (props.propertyData?.reference.length > 0) { leadId = props.propertyData?.reference } else { leadId = null }

    const listEstateType = [{ label: 'Maison', value: 'house' }, { label: 'Appartement', value: 'flat' },
      { label: 'Loft', value: 'loft' },
      { label: 'Villa', value: 'villa' }, { label: 'Terrain', value: 'field' },
      { label: 'Propriété', value: 'property' },
      { label: 'Bureau/Commerce', value: 'office_commerce' },
      { label: 'Immeuble', value: 'building' }, { label: 'Parking', value: 'parking' }]

    const estateTypesIncl = listEstateType.filter(type => type.label === props.propertyData?.type)
    // buying project
    const project = {
      buyer_id: contactId,
      comments: comment.value,
      acquisition_source: 'vitrine',
      estate_types_incl: [estateTypesIncl[0].value],
      price_max_euro: props.propertyData?.price.value,
      postal_codes_incl: [props.propertyData?.city.zipcode],
      traditional_room_number_min: props.propertyData?.rooms,
      total_area_min_m2: props.propertyData?.area.value,
      lead_id: leadId,
      alert_optin: true
    }

    await getService('buying-projects').create(project)

    isSending.value = false
    sent.value = true
  }
}
</script>

<style lang="scss" scoped>
.lead-owner-section {
  display: flex;
  align-items: center;
  margin-top: 20px;
  padding-left: 0;
  color: #1f1f1f;
  padding-bottom: 20px;
  width: fit-content;

  .name {
    font-weight: bold;
    font-size: 16px;
  }

  .role {
    font-size: 14px;
  }
}

.form-section {
  margin-top: 20px;

  .title {
    margin-bottom: 15px;
    font-size: 18px;
    font-weight: normal;
  }

  form {
    textarea {
      background: rgba($orange, 10%);
      font-size: 90%;
      padding: 0.5em;
    }

    .form-group input {
      padding: 8px;
    }

    .form-check {
      font-size: 14px;
      margin-top: 10px;
    }
  }
}

#confirmation {
  position: fixed;
  bottom: 0;
  width: 100%;
  left: 0;
  z-index: 9999;
}

:deep(#confirmation) {
  font-weight: normal;
  color: #1f1f1f;
}

:deep(#confirmation) a {
  font-weight: normal;
  color: #1f1f1f;
}

@media (width <= 768px) {
  .panel {
    margin-left: -15px;
    margin-right: -15px;
    padding: 5px;
    padding-bottom: 20px;
  }

  #confirmation {
    bottom: 140px;
  }
}
</style>
